(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mr-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mr-delivery')) {
    customElements.define('mr-delivery', class extends HTMLElement {
      connectedCallback() {
        var min = parseInt(this.dataset.min, 10) || 7;
        var max = parseInt(this.dataset.max, 10) || 15;
        var cutoff = parseInt(this.dataset.cutoff, 10) || 14;
        // Festivos nacionales en España (fijos) y Viernes Santo
        var fixed = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
        var movable = ['2026-04-03', '2027-03-26', '2028-04-14'];
        function pad(n) { return (n < 10 ? '0' : '') + n; }
        function isWorkday(d) {
          var w = d.getDay();
          if (w === 0 || w === 6) return false;
          var md = pad(d.getMonth() + 1) + '-' + pad(d.getDate());
          if (fixed.indexOf(md) > -1) return false;
          if (movable.indexOf(d.getFullYear() + '-' + md) > -1) return false;
          return true;
        }
        function addWorkdays(start, n) {
          var d = new Date(start);
          while (n > 0) {
            d.setDate(d.getDate() + 1);
            if (isWorkday(d)) n--;
          }
          return d;
        }
        var start = new Date();
        if (start.getHours() >= cutoff) start.setDate(start.getDate() + 1);
        var fmt = function (d) { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); };
        var text = this.querySelector('.mr-delivery__text');
        if (text) {
          text.innerHTML = 'Envío gratis · Llega entre el <strong>' + fmt(addWorkdays(start, min)) +
            '</strong> y el <strong>' + fmt(addWorkdays(start, max)) + '</strong> · Con seguimiento';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
